import { Link } from "react-router";
import { BackupNotice, StatusBoard } from "../components/Status";
import { Page, PageHead } from "../components/ui";
import { useReveal } from "../hooks";

export function Stand() {
  useReveal();
  return (
    <Page name="stand">
      <div className="wrap stack-lg" style={{ maxWidth: 820 }}>
        <PageHead
          eyebrow="Stand heute"
          title="HandVero ist in der Startphase"
          lead="Wir bauen HandVero Schritt für Schritt mit den ersten Betrieben. Heute können Sie sich registrieren und die Website, die Web-App auf dem Handy und die Windows-Software nutzen. Protokolle, Schulungen und weitere Module kommen später."
        />
        <StatusBoard />
        <BackupNotice />
        <div className="card">
          <h3>Registrieren und herunterladen</h3>
          <p>
            Registrieren Sie sich kostenlos. Nach Bestätigung Ihrer E-Mail-Adresse ist Ihr Konto startklar, und im Kundenbereich finden Sie den Download der
            Windows-Software.
          </p>
          <Link className="btn btn-primary" to="/registrieren" style={{ justifySelf: "start" }}>
            Kostenlos registrieren
          </Link>
        </div>
      </div>
    </Page>
  );
}
